import { Injectable } from '@angular/core';
import { AntifraudeWarning } from '../../shared/antifraud-warning/antifraud-warning';

@Injectable()
export class AntifraudWarningService {
  antifraudData: AntifraudeWarning;

  constructor() { }

  setAntifraudData(data: AntifraudeWarning){
    this.antifraudData = data;
  }

  resetAntifraudeData(){
    this.antifraudData = undefined;
  }
  
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/antifraud-warning/antifraud-warning.service.ts